export default __webpack_public_path__ + "static/media/team-photo-2015.1c1be69a.jpg";